import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageSelect } from '../../../../common/EditPage';
import { getOne, getList, create } from '../../../../common/v4/BackendProvider';
import Panel from '../../../../common/layout/Panel';

const UserAssignments = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [users, setUsers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        loadGroups();
        loadUsers();
    }, []);

    const loadGroups = async () => {
        try {
            const response = await getOne(`/admin/access/rights/`, 'new');
            setGroups(response.data.metadata.groups || {});
        } catch (error) {
            toast.error("Error loading access groups: " + error.message, {});
        }
    };

    const loadUsers = async () => {
        try {
            const response = await getList(`/admin/users/`);
            setUsers(response.data.data || []);
        } catch (error) {
            toast.error("Error loading users: " + error.message, {});
            setUsers([]);
        }
    };

    const loadGroupUsers = async (groupId) => {
        if (!groupId) {
            setAssignedUsers([]);
            setSelectedGroup(null);
            return;
        }

        setLoading(true);
        try {
            const response = await getOne(`/admin/access/groups/`, groupId);
            const group = response.data.data;
            setSelectedGroup(group);
            
            // Get users assigned to this group
            const assignedUserIds = group.users?.map(user => user.id) || [];
            setAssignedUsers(assignedUserIds);
        } catch (error) {
            toast.error("Error loading group users: " + error.message, {});
        } finally {
            setLoading(false);
        }
    };

    const handleGroupChange = (id, value) => {
        loadGroupUsers(value);
    };

    const handleUserToggle = (userId) => {
        setAssignedUsers(prev => {
            if (prev.includes(userId)) {
                return prev.filter(id => id !== userId);
            } else {
                return [...prev, userId];
            }
        });
    };

    const handleSave = async () => {
        if (!selectedGroup) {
            toast.error("Please select an access group", {});
            return;
        }

        try {
            await create(`/admin/access/groups/${selectedGroup.id}/users`, {
                data: {
                    user_ids: assignedUsers
                }
            });
            toast.success("User assignments updated successfully", {});
        } catch (error) {
            toast.error("Error updating user assignments: " + error.message, {});
        }
    };

    const handleCancel = () => {
        setSelectedGroup(null);
        setAssignedUsers([]);
    };
console.log(selectedGroup, 'selectedGroup')
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageSelect 
                        label="Access Group" 
                        id="access_group_id" 
                        onChange={handleGroupChange}
                        value={selectedGroup?.id || ''}
                        options={groups || {}}
                        required
                    />
                    <div></div>
                </EditPagePanel>
                
                <EditPagePanel>
                    <div></div>
                    {selectedGroup ? (
                        <Panel title={`User Assignments for ${selectedGroup.name || 'Unknown Group'}`}>
                            {loading ? (
                                <div className="p-6 text-center">Loading...</div>
                            ) : (
                                <div className="p-6">
                                    <div className="mb-4">
                                        <p className="text-sm text-gray-600 mb-2">
                                            Select users to assign to this access group:
                                        </p>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {users.map(user => (
                                            <div key={user.id} className="flex items-center p-3 border rounded-lg hover:bg-gray-50">
                                                <input
                                                    type="checkbox"
                                                    id={`user-${user.id}`}
                                                    checked={assignedUsers.includes(user.id)}
                                                    onChange={() => handleUserToggle(user.id)}
                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 mr-3"
                                                />
                                                <label htmlFor={`user-${user.id}`} className="flex-1 cursor-pointer">
                                                    <div className="font-medium">{user.name || 'Unknown'}</div>
                                                    <div className="text-sm text-gray-500">{user.email || 'No email'}</div>
                                                    <div className="text-xs text-gray-400">
                                                        {user.role || 'No role'} • {user.scope || 'client'}
                                                    </div>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {users.length === 0 && (
                                        <div className="text-center text-gray-500 py-8">
                                            No users found
                                        </div>
                                    )}
                                </div>
                            )}
                        </Panel>
                    ) : (
                        <div className="p-6 text-center text-gray-500">
                            Please select an access group to manage user assignments
                        </div>
                    )}
                </EditPagePanel>
                <div></div>
            </EditPage>
        </>
    );
};

export default UserAssignments; 